<!-- 2 -->
<template>
  <div class="content-wrapper">
    <div class="dbs-detail">
      <DbsParkInfoUpper :park="park" />

      <DbsParkStockAndEmpty :park="park" />

      <DbsParkInfoLower :park="park" />

      <!-- 本番環境以外 クーポン発行ボタン表示 -->
      <DbsCouponButton v-if="isNotProd" />
    </div>

    <DbsDetailButtons :park="park" />
  </div>
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDbsDetail",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isNotProd = process.env.VUE_APP_ENV !== "production";
    return {
      isNotProd,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  padding-bottom: 42px; /* 「ここへ行く」がある分、パディングを取る必要がある */
}
.dbs-detail {
  height: calc(100vh - 42px);
  overflow-y: scroll;
  padding: 2%;
  max-width: 500px;
  margin: auto;
}
</style>
